let styleSelects = require('../styled-select/styled-select');
require('./web-form.less');

$(function() {
    styleSelects.styleSelects($('.js-styled-select'));
    window.seminarFormMask && window.seminarFormMask();
});

/**
 * Маска ввода для элементов, для которых сохранен data параметр
 */

window.seminarFormMask = function() {
    if ($.fn.mask) {
        $('.web-form input[data-mask*="9"]').each(function() {
            var $this = $(this);
            var mask = $this.data('mask');
            mask && $this.mask(mask);
        });
    }
};
window.seminarEntryPage = function(seminar, date, city, seminarTime, seminarPlace, isfree) {
    window.mxLoader = window.mxLoader || undefined;
    window.common = window.common || undefined;

    var url = '/ajax/component/maximaster:seminars.form/';
    url +='?seminar=' + seminar + '&date=' + date + '&city=' + city + '&time=' + seminarTime + '&place=' + seminarPlace + '&isfree=' + isfree+ '&template=page';
    var time = new Date().getTime() + 400;

    $.ajax({
        url: url,
        success: function(result) {
            time = time - new Date().getTime();
            time = time > 0 ? time : 0;

            const content = $('.formRegistr');
            const contentFooter = $('.formRegistrFooter');

            content.html(result.html);
            contentFooter.html(result.html);

            var $select = $('.js-styled-select', content);
            var $selectFooter = $('.js-styled-select', contentFooter);
            $select && styleSelects.styleSelects($select);
            $selectFooter && styleSelects.styleSelects($selectFooter);

            setTimeout(function() {

                window.seminarFormMask && window.seminarFormMask();
                window.mxLoader && window.mxLoader.hide();

                content.on('click', 'input[type="submit"]', function(event) {
                    event.preventDefault();

                    var $this = $(this);
                    var $form = content.find('form');

                    $form.find('.additional-submit').remove();
                    $form.append(
                        '<input class="additional-submit" type="hidden" name="' +
                        this.name +
                        '" value="' +
                        this.value +
                        '" />'
                    );

                    time = new Date().getTime() + 400;
                    window.mxLoader && window.mxLoader.show();

                    $.ajax({
                        url: url,
                        data: new FormData($form.get(0)),
                        processData: false,
                        contentType: false,
                        type: 'POST',
                        success: function(data) {
                            time = time - new Date().getTime();
                            time = time > 0 ? time : 0;

                            setTimeout(function() {
                                content.html(data.html);

                                var $select = $('.js-styled-select', content);
                                $select && styleSelects.styleSelects($select);

                                window.seminarFormMask && window.seminarFormMask();
                                window.mxLoader && window.mxLoader.hide();
                            }, time);
                        }
                    });
                });
                contentFooter.on('click', 'input[type="submit"]', function(event) {
                    event.preventDefault();

                    var $this = $(this);
                    var $form = contentFooter.find('form');

                    $form.find('.additional-submit').remove();
                    $form.append(
                        '<input class="additional-submit" type="hidden" name="' +
                        this.name +
                        '" value="' +
                        this.value +
                        '" />'
                    );

                    time = new Date().getTime() + 400;
                    window.mxLoader && window.mxLoader.show();

                    $.ajax({
                        url: url,
                        data: new FormData($form.get(0)),
                        processData: false,
                        contentType: false,
                        type: 'POST',
                        success: function(data) {
                            time = time - new Date().getTime();
                            time = time > 0 ? time : 0;

                            setTimeout(function() {
                                contentFooter.html(data.html);

                                var $selectFooter = $('.js-styled-select', contentFooter);
                                $selectFooter && styleSelects.styleSelects($selectFooter);

                                window.seminarFormMask && window.seminarFormMask();
                                window.mxLoader && window.mxLoader.hide();
                            }, time);
                        }
                    });
                });
            }, time);
        }
    });
};
/**
 * Всплывашка с веб формой записи на семинар
 * @param seminar
 * @param date
 * @param city
 */


window.seminarEntry = function(seminar, date, city, seminarTime, seminarPlace, isfree) {
    window.mxLoader = window.mxLoader || undefined;
    window.common = window.common || undefined;

    var url = '/ajax/component/maximaster:seminars.form/';
    url += '?seminar=' + seminar + '&date=' + date + '&city=' + city + '&time=' + seminarTime + '&place=' + seminarPlace + '&isfree=' + isfree;

    var options = {
        classes: {
            prompt: 'web-form-popup',
            message: 'web-form-content'
        }
    };

    // Ограничение по времени загрузки формы, прелоадер
    var time = new Date().getTime() + 400;
    window.mxLoader && window.mxLoader.show();
    $.ajax({
        url: url,
        success: function(result) {
            time = time - new Date().getTime();
            time = time > 0 ? time : 0;

            setTimeout(function() {
                var $modal = $.prompt(result.html, options);
                var $content = $('.web-form-content', $modal);

                window.seminarFormMask && window.seminarFormMask();
                window.mxLoader && window.mxLoader.hide();

                // Костыль связанный с тем, что в ff FormData не понимает, на какую кнопку мы нажали
                $content.on('click', 'input[type="submit"]', function(event) {
                    event.preventDefault();

                    var $this = $(this);
                    var $form = $this.closest('form');

                    $form.find('.additional-submit').remove();
                    $form.append(
                        '<input class="additional-submit" type="hidden" name="' +
                            this.name +
                            '" value="' +
                            this.value +
                            '" />'
                    );

                    time = new Date().getTime() + 400;
                    window.mxLoader && window.mxLoader.show();

                    $('body, html').animate({ scrollTop: $content.offset().top - 15 }, 400);

                    $.ajax({
                        url: url,
                        data: new FormData($form.get(0)),
                        processData: false,
                        contentType: false,
                        type: 'POST',
                        success: function(data) {
                            time = time - new Date().getTime();
                            time = time > 0 ? time : 0;

                            setTimeout(function() {
                                $content.html(data.html);

                                var $select = $('.js-styled-select', $content);
                                $select && styleSelects.styleSelects($select);

                                window.seminarFormMask && window.seminarFormMask();
                                window.mxLoader && window.mxLoader.hide();
                            }, time);
                        }
                    });
                });
            }, time);
        }
    });
};

window.seminarConsultationEntry = function(seminar, date, city, seminarTime, seminarPlace, isfree) {
    window.mxLoader = window.mxLoader || undefined;
    window.common = window.common || undefined;

    var url = '/ajax/component/maximaster:seminars.form.consultation/';
    url += '?seminar=' + seminar + '&date=' + date + '&city=' + city + '&time=' + seminarTime + '&place=' + seminarPlace + '&isfree=' + isfree;

    var options = {
        classes: {
            prompt: 'web-form-popup',
            message: 'web-form-content'
        }
    };

    // Ограничение по времени загрузки формы, прелоадер
    var time = new Date().getTime() + 400;
    window.mxLoader && window.mxLoader.show();
    $.ajax({
        url: url,
        success: function(result) {
            time = time - new Date().getTime();
            time = time > 0 ? time : 0;

            setTimeout(function() {
                var $modal = $.prompt(result.html, options);
                var $content = $('.web-form-content', $modal);

                window.seminarFormMask && window.seminarFormMask();
                window.mxLoader && window.mxLoader.hide();

                // Костыль связанный с тем, что в ff FormData не понимает, на какую кнопку мы нажали
                $content.on('click', 'input[type="submit"]', function(event) {
                    event.preventDefault();

                    var $this = $(this);
                    var $form = $this.closest('form');

                    $form.find('.additional-submit').remove();
                    $form.append(
                        '<input class="additional-submit" type="hidden" name="' +
                            this.name +
                            '" value="' +
                            this.value +
                            '" />'
                    );

                    time = new Date().getTime() + 400;
                    window.mxLoader && window.mxLoader.show();

                    $('body, html').animate({ scrollTop: $content.offset().top - 15 }, 400);

                    $.ajax({
                        url: url,
                        data: new FormData($form.get(0)),
                        processData: false,
                        contentType: false,
                        type: 'POST',
                        success: function(data) {
                            time = time - new Date().getTime();
                            time = time > 0 ? time : 0;

                            setTimeout(function() {
                                $content.html(data.html);

                                var $select = $('.js-styled-select', $content);
                                $select && styleSelects.styleSelects($select);

                                window.seminarFormMask && window.seminarFormMask();
                                window.mxLoader && window.mxLoader.hide();
                            }, time);
                        }
                    });
                });
            }, time);
        }
    });
};



// WEBPACK FOOTER //
// ./blocks/web-form/web-form.js